module.exports = __webpack_public_path__ + "static/media/linkedIn.a2f0dc5f.png";